var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Home des Pr\xE9s") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ADD8E6",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,80 L100,40 L160,80 L160,160 L40,160 L40,80 Z",
    stroke: "#4A6DA7",
    strokeWidth: 6,
    fill: "#98FF98"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E6E6FA",
    x: 70,
    y: 100,
    width: 60,
    height: 60,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4A6DA7",
    x: 85,
    y: 120,
    width: 30,
    height: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.682500b51ee32d39cdbf10d88c5c1343.svg";
export { ForwardRef as ReactComponent };